/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Validation_HintInputs */



/**
* | output |
* | --- |
* | "Each room needs a name and at least 1 table. Not saved until fixed." |
*
* @param {Rooms_Validation_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_validation_hint = /** @type {((inputs?: Rooms_Validation_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Validation_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chaque salle doit avoir un nom et au moins 1 table. Non enregistré tant que ce n'est pas corrigé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cada sala necesita un nombre y al menos 1 mesa. No se guarda hasta corregirlo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cada sala precisa de um nome e pelo menos 1 mesa. Não é salvo até corrigir.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ogni sala deve avere un nome e almeno 1 tavolo. Non salvato finché non è corretto.")
	return /** @type {LocalizedString} */ ("Each room needs a name and at least 1 table. Not saved until fixed.")
});